import type { FC } from 'react';
import type { MainEmptyStateProps } from '../../types';

const resolveMessage = ({ hasMeetings, isFreePlan }: MainEmptyStateProps) => {
  if (isFreePlan) {
    return 'Personal meetings are not supported on a free plan';
  }
  if (hasMeetings) {
    return 'Select a meeting from the sidebar to view details.';
  }
  return 'Create a Personal Meeting ID to get started.';
};

export const EmptyState: FC<MainEmptyStateProps> = (props) => (
  <div className="personal-meetings-modal__empty-state">
    {props.isLoading ? <p>Loading personal meetings…</p> : <p>{resolveMessage(props)}</p>}
  </div>
);
